// Feedback numbers: every Feedback Inbox item already has a stable FeedbackID (db/06). It is shown as "#29" on the card
// and in the weekly digest email so people can refer to an item by number instead of by title, and the inbox search
// finds an item by it.

/** "#29" - the label shown for an item. */
export const feedbackNumberLabel = (item) => (item && item.FeedbackID != null ? `#${item.FeedbackID}` : "");

/**
 * Does an item match the search box?
 *   ""                 everything
 *   "29" / "#29"       exactly that number (a bare number is a number, not a word to find in a title)
 *   anything else      every word appears in the title, description, submitter or AI area (case-insensitive)
 */
export function matchesFeedbackQuery(item, query) {
  const q = String(query ?? "").trim();
  if (!q) return true;
  const num = /^#?\s*(\d+)$/.exec(q);
  if (num) return String(item.FeedbackID) === String(+num[1]);
  const hay = [item.Title, item.Description, item.SubmittedByName, item.AIArea].filter(Boolean).join(" ").toLowerCase();
  return q.toLowerCase().split(/\s+/).every(w => hay.includes(w));
}
